import { defineSlotRecipe } from "@chakra-ui/react";

export const selectSlotRecipe = defineSlotRecipe({
  className: "chakra-select",
  slots: [
    "root",
    "indicatorGroup",
    "indicator",
    "content",
    "control",
    "item",
    "itemText",
    "itemGroup",
    "itemGroupLabel",
    "label",
    "valueText",
    "clearTrigger",
  ],
  base: {
    root: {
      width: "full",
    },
    control: {
      borderWidth: 2,
      bgColor: "input",
      borderRadius: "md",
      borderColor: "lines",
      color: "base.700",
      textStyle: "body.standard",
      height: 12,
      alignItems: "center",
      _invalid: {
        borderColor: "error.element",
      },
      _focus: {
        borderColor: "input.focus",
      },
      _placeholder: {
        color: "base.600",
      },
    },
    item: {
      padding: "12px",
    },
    label: {
      display: "inline-flex",
    },
    valueText: {
      lineHeight: "1",
      fontWeight: "medium",
      letterSpacing: "tight",
    },
  },
  variants: {
    size: {
      xs: {
        valueText: {
          textStyle: "2xs",
        },
      },
      sm: {
        valueText: {
          textStyle: "2xs",
        },
      },
      md: {
        valueText: {
          textStyle: "xs",
        },
      },
      lg: {
        valueText: {
          textStyle: "sm",
        },
      },
      xl: {
        valueText: {
          textStyle: "sm",
        },
      },
    },
  },

  defaultVariants: {
    size: "md",
  },
});

export default selectSlotRecipe;
